import { useEffect, useState, useContext } from "react" // srini - 20/12/24
import { withStyles } from "@material-ui/core/styles"
import { Typography, Button } from '@mui/material' // srini - 20/12/24

import validator from 'validator'
import styles from "../../TabStyles"

import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig" // srini - 20/12/24
import { httpRequest } from "../../../../ui-utils/api"
import snackError from "../../../../helpers/snackError" // srini - 20/12/24

import { reducerContext } from "../../../../contextApi's/contextApi's" // srini - 20/12/24

import UsersTable from "./UsersTable"
import UsersForm from "./UserForm"
import axios from "axios"


const Users = ({ classes }) => {

    const { dispatch } = useContext(reducerContext) // srini - 20/12/24

    const [sortColumn, setSortColumn] = useState("sip_id") //
    const [sortOrder, setSortOrder] = useState("asc") //
    const [userData, setUserData] = useState([]) //
    const [addUserModal, setAddUserModal] = useState(false)
    const [newName, setNewName] = useState("")
    const [newEmail, setNewEmail] = useState("")
    const [errType, setErrType] = useState(0)
    const [errMsg, setErrMsg] = useState("")
    const [departmentError, setDepartmentError] = useState(false)
    const [department, setDepartment] = useState([0])
    const [departmentData, setDepartmentData] = useState([])
    const [secret, setSecret] = useState("")
    const [sipGroupId, setSipGroupId] = useState("")
    const [roleError, setRoleError] = useState(false)
    const [role, setRole] = useState([0])
    const [additionalRoles, setAdditionalRoles] = useState([0])
    const [menuData, setMenuDate] = useState([])
    const [editUser, setEditUser] = useState(false)
    const [roleData, setRoleData] = useState([])
    const [additionalError, setAdditionalError] = useState(false)
    const [uid, setUid] = useState(0)
    const [getData, setGetData] = useState(false)
    const [contact,setContact]=useState("")
    // srini - 20/12/24
    const [franchList, setFranchList] = useState([])
    const [franchaise, setFranchaise] = useState([])
    const [franchError, setFranchError] = useState(false)

    useEffect(() => {
        if (addUserModal) {
            (async () => {
                try {

                    const departmentdata = await httpRequest({
                        endPoint: `${apiUrl.departmentList}`,
                        method: "get",
                        instance: "instanceOne",
                    })
                    // const departmentdata = await axios.get(`http://localhost:5000/api/department/getAll`)

                    if (departmentdata?.data?.success) {
                        setDepartmentData(departmentdata.data?.result)
                    }
                    // Dev Srini 25/10/24
                    else {
                        console.log('Error in Department List API', departmentdata.data)
                    }
                } catch (error) {
                    console.log('Error in Department List API', error)
                }

                const roledata = await httpRequest({
                    endPoint: `${apiUrl.roleList}`,
                    method: "get",
                    instance: "instanceOne",
                })
                if (roledata.data?.success === true) {
                    setRoleData(roledata.data?.result)
                }
                else if (roledata?.data?.success === false) {
                    console.log('Error in Role List API', roledata)
                }

                // const menudata = await axios.get(`http://localhost:5000/api/menu/menulist`)

                const menudata = await httpRequest({
                    endPoint: `${apiUrl.menuList}`,
                    method: "get",
                    instance: "instanceOne",
                })

                if (menudata?.data?.success === true) {
                    setMenuDate(menudata?.data?.result)
                }
                else if (menudata?.data?.success === false) {
                    console.log('Error in Menu List API', menudata)
                }
                // srini - 20/12/24
                const franchaiseData = await httpRequest({
                    endPoint: `${apiUrl.franchiseeList}`, //corrected spelling by dev-trupti on 23-12-2024
                    method: "get",
                    instance: "instanceOne",
                })
                console.log(franchaiseData?.data.data?.data)

                if (franchaiseData?.data?.status === 200) {
                    setFranchList(franchaiseData?.data?.data?.data)
                }
                else if (franchaiseData.error) {
                    console.log('Error in Franchaise List API', franchaiseData.error)
                }
            })()
        }
    }, [addUserModal])

    const userDetails = async () => {
        try {
            const userdata = await httpRequest({
                endPoint: `${apiUrl.userList}`,
                method: "get",
                instance: "instanceOne",
            })
            if (userdata?.data?.success === true) {
                const sortedUserData = userdata?.data?.result
                console.log("sortedUserData", sortedUserData)
                setUserData(sortedUserData)
            }
            else if (userdata.success === false) {
                console.log('Error in User List API', userdata)
            }
        }
        catch (error) {
            console.log('Error in User List API', error)
        }
    }

    useEffect(() => {
        userDetails()
    }, [getData])

    const handleOpenUser = () => {
        setAddUserModal(true)
    }

    const handleEditUser = (data) => {

        console.log("dataaaa",data)
        const newDepartment = data.departments.map(item => item.uid) // srini - 31/12/24
        const newRole = data.roles.map(role => role.uid) // srini - 31/12/24
        const newAdditionalRole = data.additionalMenu.map(item => item.uid) // srini - 31/12/24
        const newFranch = data?.franchisee_list// srini - 20/12/24
        setEditUser(true)
        setUid(data.uid)
        setAddUserModal(true)
        setNewEmail(data.email)
        setNewName(data.name)
        setContact(data?.contact)
        setSecret(data?.secret)
        // srini - 31/12/24
        setDepartment(newDepartment.filter(value => value !== 0))
        console.log("role",newRole)
        setRole(newRole.filter(value => value !== 0))
        setAdditionalRoles(newAdditionalRole.filter(value => value !== 0))
        // setFranchaise(franchaise => [...franchaise, newFranch].filter(value => value !== "").flat())
        console.log("qqqqq", newFranch)
        setFranchaise(prev => [
            ...prev,
            ...(Array.isArray(newFranch) ? newFranch : [newFranch])
        ]
            .filter(v => v !== "" && v != null));
        const d = franchaise => [...franchaise, newFranch].filter(value => value !== "").flat()
        console.log("aaaa",d)

        setSipGroupId(data.sip_id)
    }

    const handleCloseUser = () => {
        setAddUserModal(false)
        setEditUser(false)
        setNewName("")
        setNewEmail("")
        setDepartment([0])
        setSecret("")
        setSipGroupId("")
        setRole([0])
        setAdditionalRoles([0])
        setFranchaise([""]) // srini - 20/12/24
        setErrMsg("")
        setDepartmentError(false)
        setRoleError(false)
        setAdditionalError(false)
        setContact("")
    }

    // const handleDepartmentChange = (e) => {
    //     const selectedValues = e.target.value
    //     const updatedValues = selectedValues.filter(item => item !== 0)

    //     setDepartment(updatedValues)
    // }


    const handleDepartmentChange = (event, newValue) => {
        setDepartmentError(false)
        const updatedValues = (newValue || []).filter(item => item !== 0);
        setDepartment(updatedValues);
    };


    // const handleRoleChange = (e) => {
    //     const selectedValues = e.target.value
    //     const updatedValues = selectedValues.filter(item => item !== 0)

    //     setRole(updatedValues)
    // }

    const handleRoleChange = (event, newValue) => {
        setRoleError(false)
        const updatedValues = (newValue || []).filter(item => item !== 0);
        setRole(updatedValues);
    };


    const handleAdditionalRoles = (e, newValue) => {
        setAdditionalError(false)
        const updatedValues = (newValue || []).filter(item => item !== 0);
        setAdditionalRoles(updatedValues)
    }
    // srini - 20/12/24
    // const handleFranchaiseChange = (e) => {
    //     const selectedValues = e.target.value
    //     console.log("selectedValues",selectedValues)
    //     const updatedValues = selectedValues.filter(item => item !== "")
    //     setFranchaise(updatedValues)
    // }

    const handleFranchaiseChange = (event, newValue) => {
        // newValue will be the full array of selected items
        console.log("selectedValues", newValue);
        const updatedValues = (newValue || []).filter(item => item !== "");
        setFranchaise(updatedValues);
    };

    console.log("franchiseeeee", franchaise)
    const EditUser = async () => {
        let isok = 0

        if (!newEmail.length && isok === 0) {
            isok = 1
            setErrType(1)
            setErrMsg("Enter the Email")
        }

        if (validator.isEmail(newEmail) === false && isok === 0) {

            isok = 1
            setErrType(1)
            setErrMsg("Agent Id Not Vailed")
        }

        if (!newName.length && isok === 0) {
            isok = 2
            setErrType(2)
            setErrMsg("Enter the name")
        }
        if (newName.length < 5 && isok === 0) {
            isok = 2
            setErrType(2)
            setErrMsg("name is too short")
        }

        if (!contact.length && isok === 0) {
            isok = 5
            setErrType(5)
            setErrMsg("Enter Contact No")
        }

        if (contact.length < 10 && isok === 0) {
            isok = 5
            setErrType(5)
            setErrMsg("Contact No should min 10 digits")
        }

        if (!secret.length && isok === 0) {
            isok = 3
            setErrType(3)
            setErrMsg("Enter the Secret Key")
        }

        if (!sipGroupId && isok === 0) {
            isok = 4
            setErrType(4)
            setErrMsg("Enter Valid sip group id")
        }

        if (isok === 0) {
            // Validation re written - srini - 20/12/24
            if (department[0] === "0" || department.length === 0) {
                setDepartmentError(true)
            } else {
                setDepartmentError(false)
            }

            if (role[0] === "0" || role.length === 0) {
                setRoleError(true)
            } else {
                setRoleError(false)
            }
           
            // Srini - 24/12/24
            // if (franchaise.length === 0 || franchaise[0] === "") {
            //     setFranchError(true)
            // } else {
            //     setFranchError(false)
            // }

            // if (additionalRoles[0] === "0" || additionalRoles.length === 0) {
            //     setAdditionalError(true)
            // }
            // else {
            //     setAdditionalError(false)
            // }

            if (
                department.length > 0 && department[0] !== "0" &&
                role.length > 0 && role[0] !== "0"
                // franchaise.length > 0 && franchaise[0] !== "" && // Srini - 24/12/24
                // additionalRoles.length > 0 && additionalRoles[0] !== "0"
            ) {

                // franchaise.length > 0 && franchaise[0] !== "" && handleAddFranchaise() // srini - 31/12/24


                let edituserdata = {
                    uid: uid,
                    name: newName,
                    email: newEmail,
                    contact,
                    secret: secret,
                    sip_id: parseInt(sipGroupId),
                    departments: department,
                    roles: role,
                    // franchaise_list:franchaise,
                    menus: additionalRoles[0] == 0 ? [] : additionalRoles,
                }

                console.log("edituserdata", edituserdata)

                try {

                    const edituser = await httpRequest({
                        endPoint: `${apiUrl.userModify}`,
                        method: "put",
                        instance: "instanceOne",
                        requestBody: edituserdata,

                    })
                    if (edituser.data?.success === true) {

                        setEditUser(false)
                        setAddUserModal(false)
                        setGetData(!getData)
                        setNewName("")
                        setNewEmail("")
                        setSecret("")
                        setDepartment([0])
                        setRole([0])
                        setAdditionalRoles([0])
                        setFranchaise([])
                        setSipGroupId([0])
                        setDepartmentError(false)
                        setRoleError(false)
                        setAdditionalError(false)

                        dispatch({
                            type: 'SET_SHOW_ERROR',
                            payload: true
                        })

                        dispatch({
                            type: 'SET_ERROR',
                            payload: 'User Edit Success.'
                        })
                        dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
                    }
                    else {
                        console.log('Error in User Modify API', editUser)

                        dispatch({
                            type: 'SET_SHOW_ERROR',
                            payload: true
                        })

                        dispatch({
                            type: 'SET_ERROR',
                            payload: 'Error in User Edit.'
                        })

                        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                    }
                }
                catch (error) {
                    console.log('Error in User Modify API', error)

                    dispatch({
                        type: 'SET_SHOW_ERROR',
                        payload: true
                    })

                    dispatch({
                        type: 'SET_ERROR',
                        payload: 'Error in User Edit.'
                    })

                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                }
            }
        }
    }

    const CreateUser = async () => {
        let isok = 0

        if (!newEmail.length && isok === 0) {
            isok = 1
            setErrType(1)
            setErrMsg("Enter the Email")
        }

        if (validator.isEmail(newEmail) === false && isok === 0) {
            isok = 1
            setErrType(1)
            setErrMsg("Agent Id Not Valid")
        }

        if (!newName.length && isok === 0) {
            isok = 2
            setErrType(2)
            setErrMsg("Enter the Name")
        }

        if (newName.length < 5 && isok === 0) {
            isok = 2
            setErrType(2)
            setErrMsg("Name is too short")
        }

        if (!secret.length && isok === 0) {
            isok = 3
            setErrType(3)
            setErrMsg("Enter the Secret Key")
        }

        if (!sipGroupId.length && isok === 0) {
            isok = 4
            setErrType(4)
            setErrMsg("Enter the sip group id")
        }

        if (!contact.length && isok === 0) {
            isok = 5
            setErrType(5)
            setErrMsg("Enter Contact No")
        }

        if (contact.length < 10 && isok === 0) {
            isok = 5
            setErrType(5)
            setErrMsg("Contact No should min 10 digits")
        }

        const hostname = window.location.hostname

        if (hostname === 'crm-frontend.tradeboss') {
            // Production environment
            if (sipGroupId.length !== 6 && isok === 0) {
                isok = 4
                setErrType(4)
                setErrMsg("Enter Valid sip group id")
            }
        } else if (hostname.includes("staging") || hostname === 'localhost') {
            // Staging environment or localhost
            if (sipGroupId.length !== 5 && isok === 0) {
                isok = 4
                setErrType(4)
                setErrMsg("Enter Valid sip group id")
            }
        }


        // Validation re written - srini - 20/12/24
        if (isok === 0) {
            if (department[0] === 0 || department.length === 0) {
                setDepartmentError(true)
            } else {
                setDepartmentError(false)
            }

            if (role[0] === 0 || role.length === 0) {
                setRoleError(true)
            } else {
                setRoleError(false)
            }

            // if (franchaise.length === 0 || franchaise[0] === "") {
            //     setFranchError(true)
            // } else {
            //     setFranchError(false)
            // }
            // Srini - 24/12/24
            // if (additionalRoles[0] === 0 || additionalRoles.length === 0) {
            //     setAdditionalError(true)
            // }
            // else {
            //     setAdditionalError(false)
            // }

            if (
                department.length > 0 && department[0] !== 0 &&
                role.length > 0 && role[0] !== 0
                // franchaise.length > 0 && franchaise[0] !== "" && // Srini - 24/12/24
                // additionalRoles.length > 0 && additionalRoles[0] !== 0
            ) {
                // franchaise.length > 0 && franchaise[0] !== "" && handleAddFranchaise() // srini - 31/12/24
                let newuserdetails = {
                    name: newName,
                    email: newEmail,
                    contact,
                    secret: secret,
                    departments: department,
                    roles: role,
                    menus: additionalRoles[0] == 0 ? [] : additionalRoles,
                    sip_id: parseInt(sipGroupId),
                    // franchaise_list: franchaise
                }

                console.log("newuserdetails", newuserdetails)

                try {
                    const newuserdata = await httpRequest({
                        endPoint: `${apiUrl.userCreate}`,
                        method: "post",
                        instance: "instanceOne",
                        requestBody: newuserdetails,

                    })
                  
                    console.log("response",newuserdata?.data?.success)
                      
                            if (newuserdata?.data?.success === true) {
                                console.log("newuserdata", newuserdata)

                        setAddUserModal(false)
                        setNewName("")
                        setNewEmail("")
                        setSecret("")
                        setDepartment([0])
                        setRole([0])
                        setAdditionalRoles([0])
                        setSipGroupId([0])
                        setGetData(!getData)
                        setFranchaise([])
                        dispatch({
                            type: 'SET_SHOW_ERROR',
                            payload: true
                        })
                        dispatch({
                            type: 'SET_ERROR',
                            payload: 'User Created.'
                        })
                        dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc})
                    }
                    else {
                        console.log('Error in User Create API', newuserdata)

                        dispatch({
                            type: 'SET_SHOW_ERROR',
                            payload: true
                        })

                        dispatch({
                            type: 'SET_ERROR',
                            payload: 'Error in User Creation.'
                        })
                        dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                    }
                }
                catch (error) {
                    console.log('Error in User Create API', error)

                    dispatch({
                        type: 'SET_SHOW_ERROR',
                        payload: true
                    })

                    dispatch({
                        type: 'SET_ERROR',
                        payload: 'Error in User Creation.'
                    })
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                }
            }
        }
    }

    const handleAddFranchaise = async () => {
        const franchDetails = {
            user_email: newEmail,
            franchise_id_list: franchaise
        }

        try {
            const addFranch = await httpRequest({
                endPoint: `${apiUrl.addUserFranchise}`,
                method: "post",
                instance: "instanceOne",
                requestBody: franchDetails,
            })

            if (addFranch.success === true) {
                setTimeout(() => {
                    dispatch({
                        type: 'SET_SHOW_ERROR',
                        payload: true
                    })

                    dispatch({
                        type: 'SET_ERROR',
                        payload: 'Franchaise Added'
                    })
                }, 2000)

            } else {
                console.log('Error in Add Franchise API', addFranch)

                setTimeout(() => {
                    dispatch({
                        type: 'SET_SHOW_ERROR',
                        payload: true
                    })

                    dispatch({
                        type: 'SET_ERROR',
                        payload: 'Error in User Creation.'
                    })

                    dispatch({
                        type: 'SET_MY_SNACK',
                        payload: snackError.myError
                    })
                }, 2000)
            }
        }
        catch (error) {
            console.log('Error in Add Franchise API', error)

            setTimeout(() => {
                dispatch({
                    type: 'SET_SHOW_ERROR',
                    payload: true
                });

                dispatch({
                    type: 'SET_ERROR',
                    payload: 'Error in User Creation.'
                });

                dispatch({
                    type: 'SET_MY_SNACK',
                    payload: snackError.myError
                })
            }, 2000)
        }
    }


    const handleSortUsers = (column) => {
        let sort_Order = 'asc'
        if (sortColumn === column && sortOrder === 'asc') {
            sort_Order = 'desc'
        }

        const sortedUserData = [...userData].sort((a, b) => {
            if (sort_Order === 'asc') {
                if (typeof a[column] === 'string') {
                    return a[column].localeCompare(b[column])
                } else {
                    return a[column] - b[column]
                }
            } else {
                if (typeof a[column] === 'string') {
                    return b[column].localeCompare(a[column])
                } else {
                    return b[column] - a[column]
                }
            }
        })
        setUserData(sortedUserData)
        setSortColumn(column)
        setSortOrder(sort_Order)
    }

    return (
        <div style={{ flex: '82%', marginLeft: '2%', height: "100vh" }}>
            <Typography
                className={classes.dashboardText2}
                style={{ color: "#FFFFFF", marginTop: "8%" }}
            >
                Users
            </Typography>
            <Button style={{ width: '172px', height: '20px', border: '2px solid red', margin: '1% 0 1% 83%' }} >
                <span className={classes.addUserText} style={{ textTransform: 'none' }} onClick={handleOpenUser}> Add New User </span>
            </Button>

            <UsersTable
                handleSortUsers={handleSortUsers} sortColumn={sortColumn} sortOrder={sortOrder} userData={userData} handleEditUser={handleEditUser}
            />

            <UsersForm
                handleCloseUser={handleCloseUser}
                newEmail={newEmail}
                newName={newName}
                setNewEmail={setNewEmail}
                setNewName={setNewName}
                setErrType={setErrType}
                errType={errType}
                errMsg={errMsg}
                department={department}
                handleDepartmentChange={handleDepartmentChange}
                departmentData={departmentData}
                secret={secret}
                setSecret={setSecret}
                sipGroupId={sipGroupId}
                setSipGroupId={setSipGroupId}
                role={role}
                handleRoleChange={handleRoleChange}
                roleData={roleData}
                additionalRoles={additionalRoles}
                handleAdditionalRoles={handleAdditionalRoles}
                menuData={menuData}
                additionalError={additionalError}
                editUser={editUser}
                CreateUser={CreateUser}
                EditUser={EditUser}
                departmentError={departmentError}
                roleError={roleError}
                addUserModal={addUserModal}
                franchList={franchList} // srini - 20/12/24
                franchaise={franchaise} // srini - 20/12/24
                handleFranchaiseChange={handleFranchaiseChange} // srini - 20/12/24
                franchError={franchError} // srini - 20/12/24
                contact={contact}
                setContact={setContact}
            />

        </div>
    )
}
export default withStyles(styles)(Users);

